import { Link } from "react-router-dom";
import { CATEGORY_LABELS } from "../lib/constants";

// An emerald-tinted well holding white numbered slips — the one saturated
// block on the lead band, so the eye finds it straight after the lead story.
export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="sticky top-36 bg-accent-soft border border-line border-t-[3px] border-t-accent p-5">
            <div className="pb-3 mb-4 border-b border-line">
                <h4 className="font-display text-lg font-bold leading-none text-accent">Trending Now</h4>
            </div>
            <ol className="space-y-2">
                {items.map((a, i) => (
                    <li key={a.id}>
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-3 bg-surface border border-line p-3 hover:border-line-strong transition-colors duration-150"
                        >
                            <span className="font-mono text-[13px] font-medium text-accent w-6 shrink-0 pt-0.5 tabular-nums">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="min-w-0">
                                <span className="eyebrow !text-[10px] text-dim">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-display text-sm font-semibold leading-[1.35] mt-1 text-foreground group-hover:text-accent transition-colors duration-150">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-dim py-2">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
